/**
 * Auth hook for easy access to authentication state and actions.
 */

import { useAuthStore } from '@/store/authStore';

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    fetchUser,
    clearError,
  } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    fetchUser,
    clearError,
    isAdmin: user?.is_admin || false,
    isInternal: user?.user_type === 'internal',
    isExternal: user?.user_type === 'external',
  };
};
